export const STORE = {
  name: "RamVilas Kitchen & Hardware Store",
  short: "RamVilas",
  address: "Gali No. 4, Village Mamura, Sector 66, Noida, Uttar Pradesh 201301, India",
  addressShort: "Gali No. 4, Village Mamura, Sector 66, Noida",
  whatsapp: "918377852793",
  whatsappDisplay: "+91 83778 52793",
  altPhone: "+918750526259",
  altPhoneDisplay: "+91 87505 26259",
};

const dest = encodeURIComponent(STORE.address);
const placeQuery = encodeURIComponent(`RamVilas Kitchen & Hardware Store, Mamura, Sector 66, Noida`);

export const LINKS = {
  directions: `https://www.google.com/maps/dir/?api=1&destination=${dest}`,
  // TODO(owner): replace with your exact Google Business Profile reviews link
  reviews: `https://www.google.com/maps/search/?api=1&query=${placeQuery}`,
  mapEmbed: `https://maps.google.com/maps?q=${dest}&z=16&output=embed`,
  call: `tel:${STORE.altPhone}`,
  callPrimary: `tel:+${STORE.whatsapp}`,
};

export function whatsappLink(message) {
  return `https://wa.me/${STORE.whatsapp}?text=${encodeURIComponent(message)}`;
}

export function productEnquiry(p, variant, brand) {
  const lines = [
    `Namaste RamVilas Store! I'd like to enquire about:`,
    `• ${p.name}`,
    brand && `• Brand: ${brand}`,
    p.material && `• Material: ${p.material}`,
    (variant || p.size) && `• Size/Variant: ${variant || p.size}`,
    p.sku && `• SKU: ${p.sku}`,
    `Please share availability and price. Dhanyavaad!`,
  ];
  return whatsappLink(lines.filter(Boolean).join("\n"));
}

export const GENERAL_ENQUIRY = whatsappLink("Namaste RamVilas Store! I have a question about a product.");
